import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'INSTITUTION/PEOPLE/TABS';

export const {action: selectTab} = createAction(`${domain}/SELECT_TAB`, tabKey => ({tabKey}));
